export const MAX_FILE_UPLOAD_SIZE = 2 * 1024 * 1024;

export const BREAKPOINTS = {
  mobile: 0,
  tablet: 640,
  laptop: 1024,
  desktop: 1280,
};

export const META_IMAGE_URL = "https://unilinks.co/image/unilinks-meta-tmp.png";
